import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/service/api.service';
import { Observable } from 'rxjs';
import { Atribute } from '../model/potential-customer';

@Injectable({
  providedIn: 'root'
})
export class PotentialCustomerService {

  constructor(
    private apiSrv: ApiService
  ) {
  }

  validateCP(data:any): Observable<Atribute[]>   {
    const endpoint: string ='api/get-attributes-for-state-and-zip-code';
    const zipCodeParam : string = encodeURIComponent(data.zipCode);
    const stateParam : string = encodeURIComponent(data.state);
    return this.apiSrv.get(endpoint + '?state='+ stateParam +'&'+'zipCode='+zipCodeParam , { showError: true });
  }
}



